<template>
    <div>
        <h1 class="display-heading">Thank You!</h1>
        <p>Many thanks for using our service. An email will be sent to you for paying the cost of your medicine(s), should any medicine is prescribed by doctor during video consultation.</p>
        <router-link :to="{'name': 'user-doctor-appointments'}" class="mt-3 btn btn-primary btn-primary-insv">Back to Video Consultation List</router-link>
    </div>
</template>

<script>
export default {
    'name': 'EndConsultationThankYouPage'
};
</script>

<style>

</style>
